import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const INVALID_FILENAME_CHARS_REGEX = /[/\\:*?"<>|]/;
const INVALID_CHARS_DISPLAY = '/ \\ : * ? " < > |';

export function surveyNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const hasInvalid = INVALID_FILENAME_CHARS_REGEX.test(control.value);
    return hasInvalid
      ? { invalidFilenameChars: { message: `Survey name cannot contain: ${INVALID_CHARS_DISPLAY}` } }
      : null;
  };
}
